import dayjs from '@/lib/dayjs'
import { cn } from '@/lib/utils'
import SelectInput, { type SelectInputProps } from './SelectInput'

export const HOUR_ID_FORMAT = 'HH:mm'
export const HOUR_NAME_FORMAT = 'h:mm A'

export type HourInputProps = SelectInputProps & {
  minHour?: string
  maxHour?: string
}

function HourInput({
  disabled,
  options,
  className,
  minHour,
  maxHour,
  size = 'default',
  ...props
}: HourInputProps) {
  const defaultOptions = Array.from({ length: 24 }, (_, hour) => {
    const date = dayjs().hour(hour).minute(0)
    const halfHour = date.add(30, 'minute')

    return [
      {
        id: date.format(HOUR_ID_FORMAT),
        name: date.format(HOUR_NAME_FORMAT),
      },
      {
        id: halfHour.format(HOUR_ID_FORMAT),
        name: halfHour.format(HOUR_NAME_FORMAT),
      },
    ]
  })
    .flat()
    .filter(({ id }) => {
      const bigEnough = minHour ? id >= minHour : true
      const smallEnough = maxHour ? id <= maxHour : true
      return bigEnough && smallEnough
    })

  const selectOptions = options ?? defaultOptions

  return (
    <SelectInput
      className={cn('', className)}
      options={selectOptions}
      disabled={disabled}
      placeholder={'Select a time'}
      size={size}
      {...props}
    />
  )
}

export default HourInput
